import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app";
import "./styles/index.css";
import "maplibre-gl/dist/maplibre-gl.css";

const container = document.getElementById("root");

const root = createRoot(container);

root.render(<App />);
